export default function TheoromLogo({className, color, version}: {className?: string, color?: string, version?: string}) {
    return (
        version == "icon" ? (
            <img src="/img/t-logo.svg" alt="Theorom t logo" className={`h-4 rounded-xs ${className}`} />
        ) : (
            color === "white" ? (
                <img src="/img/theorom_logo-white.svg" alt="theorom AI" className={className} />
            ) : (
                <img src="/img/theorom_logo-black.svg" alt="theorom AI" className={className} />
            )
        )
    )
}